module.exports = __webpack_public_path__ + "html/subscription-current-plan-container_3abd2dbff6f454536342c52ca2403201.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/containers/subscription-current-plan-container.html
// module id = TUYZ
// module chunks = 66